import type { GuideStep } from '../types';

/**
 * Short (~6-step) tour for anonymous (not signed-in) visitors.
 * Covers the bare essentials and ends with a CTA to sign in for the tailored experience.
 */
export const GENERIC_STEPS: GuideStep[] = [
  {
    id: 'generic-1',
    page: 'index',
    section: 'generic',
    target: 'topbar',
    title: { sv: 'Välkommen till Flow Weaver', en: 'Welcome to Flow Weaver' },
    body: {
      sv: 'Det här är toppraden — spara, ladda, exportera och ångra/gör om finns här.',
      en: 'This is the top bar — save, load, export and undo/redo live here.',
    },
    placement: 'bottom',
    order: 1,
  },
  {
    id: 'generic-2',
    page: 'index',
    section: 'generic',
    target: 'tool-sidebar',
    title: { sv: 'Verktygspanelen', en: 'The tool sidebar' },
    body: {
      sv: 'Dra block härifrån ut på canvasen för att bygga ditt workflow.',
      en: 'Drag blocks from here onto the canvas to build your workflow.',
    },
    placement: 'right',
    order: 2,
  },
  {
    id: 'generic-3',
    page: 'index',
    section: 'generic',
    target: 'canvas',
    title: { sv: 'Canvasen', en: 'The canvas' },
    body: {
      sv: 'Panorera med Space + drag, zooma med Ctrl+scroll. Blocken snappar till ett 20 px-rutnät.',
      en: 'Pan with Space + drag, zoom with Ctrl+scroll. Blocks snap to a 20 px grid.',
    },
    placement: 'auto',
    order: 3,
  },
  {
    id: 'generic-4',
    page: 'index',
    section: 'generic',
    target: 'properties',
    mobileTarget: null,
    title: { sv: 'Egenskaper', en: 'Properties' },
    body: {
      sv: 'Markera ett block så visas dess inställningar här — namn, typ och färg.',
      en: 'Select a block and its settings appear here — name, type and color.',
    },
    placement: 'left',
    order: 4,
  },
  {
    id: 'generic-5',
    page: 'index',
    section: 'generic',
    target: 'canvas',
    title: { sv: 'Koppla ihop block', en: 'Connect blocks' },
    body: {
      sv: 'Håll musen över ett block, klicka på en av dess 8 portar och dra till ett annat block.',
      en: 'Hover a block, click one of its 8 ports and drag to another block.',
    },
    placement: 'auto',
    order: 5,
  },
  {
    id: 'generic-6',
    page: 'index',
    section: 'generic',
    target: 'topbar',
    title: { sv: 'Logga in för mer', en: 'Sign in for more' },
    body: {
      sv: 'Logga in för att spara i molnet, dela arbetsytor och få en personligt anpassad onboarding baserat på vad du bygger.',
      en: 'Sign in to save to the cloud, share workspaces and get a personalized onboarding based on what you build.',
    },
    placement: 'bottom',
    order: 6,
  },
];
